import { getGroupsSettingsData } from './unifiedGroupActions';

export const loadGroupsHubDataRequiedForDefaultView = dispatch => {
    getGroupsSettingsData(dispatch);
};
